export default "__VITE_ASSET__CpBbgmDu__"